import { useUpgrade } from "@/context/UpgradeContext";
import { Lock, Crown, Sparkles } from "lucide-react";

const LockedTool = ({ toolName }) => {
  const { openUpgrade } = useUpgrade();

  return (
    <div className="flex items-center justify-center py-10" data-testid="locked-tool">
      <div className="relative overflow-hidden border border-teal-500/30 bg-zinc-900/30 rounded-2xl p-8 max-w-md text-center">
        <div className="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-teal-400/10 blur-3xl pointer-events-none" />
        <div className="relative">
          <div className="h-14 w-14 mx-auto rounded-2xl bg-teal-400/10 border border-teal-500/30 flex items-center justify-center text-teal-300 mb-4">
            <Lock className="h-6 w-6" />
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-teal-300 mb-2 flex items-center justify-center gap-1">
            <Crown className="h-3.5 w-3.5" /> Pro Tool
          </p>
          <h2 className="font-heading text-2xl font-black tracking-tight text-zinc-100">{toolName} is a Pro tool</h2>
          <p className="text-sm text-zinc-400 mt-3 leading-relaxed">
            Free users get {`Tool 01`} with 3 total generations. Upgrade to IndieLaunchkit Pro for
            unlimited generations and full access to all 3 tools.
          </p>
          <button
            onClick={() => openUpgrade(`${toolName} is available on the Pro plan.`)}
            data-testid="locked-upgrade-btn"
            className="mt-6 inline-flex items-center justify-center gap-2 bg-teal-400 text-zinc-950 font-semibold py-3 px-6 rounded-xl hover:bg-teal-300 transition-colors duration-200 active:scale-95"
          >
            <Sparkles className="h-4 w-4" /> Upgrade to Pro
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockedTool;
